import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './routes';
import { InstallPWABanner, UpdateNotification } from './components/common';
import { useAppVersion } from './hooks/useAppVersion';
import './App.css';

function App() {
  const { hasUpdate, newVersion, reloadApp } = useAppVersion();

  return (
    <>
      {hasUpdate && <UpdateNotification onUpdate={reloadApp} version={newVersion} />}
      <Router>
        <AuthProvider>
          <AppRoutes />
          <InstallPWABanner />
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
